
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Save from "@/components/Builder/TopBar/Save.vue";
import { uiStore } from "@/store/store";
import { breakdanceUndo } from "@/lib/undo/undo";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Save,
    Icon
  }
})
export default class TopNavSave extends Vue {
  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  lastSaved: Date = new Date();

  unsubscribe: null | (() => void) = null;

  mounted() {
    this.unsubscribe = this.$store.subscribe(mutationPayload => {
      if (!breakdanceUndo.shouldMutationBeIgnored(mutationPayload)) {
        uiStore.setUnsavedChangesPresent(true);
      }
    });
  }

  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  }
}
